<app-carousel-offer></app-carousel-offer>
<app-category-sender-component></app-category-sender-component>
<app-footer></app-footer>